import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import ToPost from "./ToPost";

const Header = () => {
  const [showInfo, setShowInfo] = useState(false);

  const HeaderContainer = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-self: center;
    width: 95vw;
    margin-top: 20px;
    /* margin: 20px; */
  `;

const LinkHeader = styled(Link)`
text-decoration: none;

`
  const Header = styled.header`
    /* font-family: 'Heebo', sans-serif; */
    font-family: "aktiv-grotesk", sans-serif;
    font-size: 60px;
    font-weight: lighter;
    line-height: 60px;
    color: gray;
    /* padding: 40px 0; */

    @media (min-width: 375px) and (max-width: 912px) {
      font-size: 40px;
    }
  `;
  const Span = styled.span`
  /* font-family: 'Nuosu SIL', serif; */
  /* font-family: "aktiv-grotesk", sans-serif; */
  font-style: italic;
  font-weight: 600;
  color: black;
  
 
    /* color: rgb(180, 20, 100); */
  `;
  const Border = styled.div`
    height: 1px;
    background-color: red;
    margin-top: 10px;
  `;

  const InfoSection = styled.section`
  
    width: 95vw;
    margin: 10px 0 10px 0;

    @media (min-width: 992px) {
        width: 50vw;
        align-self: center;
    }
  `;

  const InfoBox = styled.h3`
    /* font-family: 'Nuosu SIL', serif; */
    display: flex;
    font-family: "aktiv-grotesk", sans-serif;
    font-weight: 400;
    font-size: 14px;
    padding: 0;
    /* width: 60px; */
    background-color: transparent;
    color: gray;
    border-radius: 5px;
  `;

  const InfoText = styled.p`
    /* font-family: 'Heebo', sans-serif; */
    font-family: "aktiv-grotesk", sans-serif;
    /* padding: 10px; */
    font-weight: 100;
    border: .3px solid black;
    border-radius: 5px;
    font-size: 16px;
    line-height: 40px;
  `;

  const InfotTextOne = styled.p`
  /* font-family: 'Heebo', sans-serif; */
  font-family: "aktiv-grotesk", sans-serif;
    font-weight: 200;
    font-size: 16px;
    line-height: 40px;
    font-style: italic;
  
  `

  const ExtraInfo = styled.span`
    display: block;
    font-size: 14px;
    margin-top: 10px;
    font-style: italic;
  `;

  const ShowButton = styled.button`
    /* font-family: 'Heebo', sans-serif; */
    font-family: "aktiv-grotesk", sans-serif;
  align-self: center;
    font-style: italic;
    font-size: 20px;
    font-weight: bold;
    border: none;
    color: gray;
    background: none;

    &:hover {
      background-color: yellow;
    }

    @media (min-width: 375px) and (max-width: 912px) {
      font-size: 16px;
    }
  `;

  // const HideButton = styled(ShowButton)`
    
  // `;

//   const ContactWrapper = styled.div`
  
//   `;
//   const LinkTo = styled(Link)`
//     font-size: 60px;
//     color: darkcyan;
//     font-family: "Spartan", sans-serif;
//   `;

  return (
    <HeaderContainer>
    <LinkHeader to="/">
      <Header>
        TELL ME, <Span>VERA</Span>:
      </Header>
      </LinkHeader>

      <Border></Border>

      <InfoSection>
        <InfoBox>
          
          <ShowButton onClick={() => setShowInfo((s) => !s)}>What is this?</ShowButton>
          {/* <HideButton onClick={() => setShowInfo(false)}>-</HideButton> */}
        </InfoBox>

        {showInfo ? (
          <InfoText>
          <InfotTextOne>Who are you?</InfotTextOne>
        I found an album full of old photo negatives at a second hand shop
            in Old Town, Stockholm. Curious as I am, I decided to take care of them and see what
            they showed. What you see here is some of the images I found. I have added color to some of them and they are most likely not the true colors, but I only have my imagination to go by.
             All I know is a name from a note, Vera. Now I want to know who she is, or was. Do you know?
            <ExtraInfo>
              * If you are one of the people in the pictures or if you are
              related to any of them, I will happily give you copies!
            </ExtraInfo>
          </InfoText>
        ) : null}
      </InfoSection>

      <ToPost />
      
    </HeaderContainer>
  );
};

export default Header;
